// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"f1887bf8","348":"b4b71326","571":"05950fdc","924":"711a509a"}[chunkId] + ".chunk.js";
};